module.exports = __webpack_public_path__ + "img/cek-aja-new-rekening.fe097a3f.png";